import React from "react";
import {Container} from "react-bootstrap";
import {Link} from "react-router-dom";

function SeaGrapes() {
    return (
        <Container>
            <h5 className="author-label">
                <Link to="/reading/sea-grapes">
                    Sea Grapes
                </Link>
            </h5>
            <p>
                ...
            </p>
        </Container>
    )
}

export default SeaGrapes;
